import { ServiceAgent, ICallResponse } from 'grey-service-agent';
import { Fns } from 'grey-group-function';
import { serverDomain } from '../entry/configUtils';
import * as Tools from './Tools';

const serviceAgent = new ServiceAgent<ICallResponse>();

serviceAgent.domain = serverDomain(); // 配置网关

// 请求前函数组
serviceAgent.reqFs = [
    Tools.addLoading, // 添加加载接口
    Tools.repeatCallStart, // 重复请求开始
    Tools.addContentType, // 添加头信息 Content-Type
    Tools.addAuthorization, // 添加头信息 Authorization
    Tools.addAppKey, // 添加头信息 x-kxl-app-key
    Tools.addLanguage, // 添加头信息 x-kxl-language
];

// 请求后函数组
serviceAgent.resFs = [
  
    Tools.verificationResponse, // 验证服务器数据是否错误
    Tools.purview, // 未权限处理
    Tools.removeLoading, // 删除加载接口
    Tools.repeatCallEnd, // 重复请求结局
    Tools.loginInvalid, // 登录失效处理
    Tools.extractData, // 提取业务数据
];

/** 不提示错信息 */
const NO_MESSAGE: Fns = serviceAgent.resFs.filter(v => v !== Tools.verificationResponse);

/** 验证 Token */
const VERIFICATION_TOKEN: Fns = serviceAgent.reqFs.slice();
VERIFICATION_TOKEN.push(Tools.isHaveToken);

export default serviceAgent;

export { Tools, NO_MESSAGE, VERIFICATION_TOKEN };


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/service/index.ts